module.exports = __webpack_public_path__ + "static/media/banner_02.33bb9a68.svg";